<template>
  <div class="photo-upload">
    <div class="photo-upload-row">
      <div class="qr-inline">
        <canvas :id="canvasId" width="132" height="132" />
      </div>
      <div class="photo-thumbs">
        <div class="preview__li" v-for="(item, index) in images" :key="item.id || index">
          <el-image :src="item.imgUrl" :preview-src-list="previewList" style="width: 100%; height: 100%" />
          <i class="el-icon-error" @click="delImg(item, index)"></i>
        </div>
        <el-upload class="uploader" action="" :show-file-list="false" :http-request="uploadToOSS" accept="image/*"
          multiple v-if="images.length < 5">
          <div class="photo-box">＋</div>
        </el-upload>
      </div>
      <div class="photo-actions">
        <el-button :loading="loading" @click="getImages(true)">获取图片</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import axios from "axios";
import { getApplyCode, imgByQr, OSSsign, imgSaveByQr, deleteImageByQrApi } from "@/apis/inHouse";

export default {
  name: "PhotoUpload",
  data() {
    return {
      // 二维码 canvas id
      canvasId: "inbound-exception-qr-" + String(Math.random()).replace("0.", ""),
      // 图片关联编码
      qrCode: "",
      // 已保存图片
      images: [],
      // 获取图片 loading
      loading: false,
    };
  },
  computed: {
    // 预览列表
    previewList: function () {
      return this.images.map((item) => item.imgUrl);
    },
    // 扫码打开的 H5 完整地址
    qrUrl: function () {
      return this.buildWmsImgUploadUrl(this.qrCode);
    },
  },
  watch: {
    qrUrl: {
      immediate: true,
      handler: function (val) {
        if (!val) {
          return;
        }
        this.$nextTick(() => {
          const canvas = document.getElementById(this.canvasId);
          if (!canvas) {
            return;
          }
          QRCode.toCanvas(canvas, val, { width: 132, margin: 1 }, function (error) {
            if (error) {
              console.error(error);
            }
          });
        });
      },
    },
  },
  methods: {
    // 按当前后台环境拼 H5 扫码地址
    buildWmsImgUploadUrl: function (uploadToken) {
      if (!uploadToken) {
        return "";
      }
      const payload = "/wmsImgUpload?uploadToken=" + uploadToken;
      const href = window.location.href;
      const apiIp = process.env.VUE_APP_API_IP || "";
      if (href.indexOf("localhost") > -1) {
        return "http://localhost:3999" + payload;
      }
      if (href.indexOf("20260917-mabang") > -1) {
        return "https://20260917-mabang-m-atlas.theckb.com" + payload;
      }
      if (
        href.indexOf("pre-system") > -1 ||
        href.indexOf("pre-") > -1 ||
        apiIp.indexOf("pre") > -1 ||
        process.env.VUE_APP_PROD === "pre"
      ) {
        return "https://pre-m-atlas.theckb.com" + payload;
      }
      if (process.env.VUE_APP_PROD === "prod" || apiIp.indexOf("gateway-prod") > -1) {
        return "https://m-atlas.theckb.com" + payload;
      }
      return "https://m-atlas.theckb.com" + payload;
    },
    // 新增时申请图片码
    initNew: function () {
      this.images = [];
      getApplyCode({ num: 1 }).then(({ code, data }) => {
        if (code === 0) {
          this.qrCode = data[0];
        }
      });
    },
    // 编辑时沿用已有图片码
    initExist: function (picRelation) {
      this.qrCode = picRelation || "";
      this.images = [];
      if (this.qrCode) {
        this.getImages();
      } else {
        this.initNew();
      }
    },
    // 当前图片关联编码
    getPicRelation: function () {
      return this.qrCode;
    },
    // 按关联编码拉取图片，showEmptyTip 为点击获取图片时的空结果提示
    getImages: function (showEmptyTip) {
      if (!this.qrCode) {
        this.$message.warning("图片编码未生成");
        return;
      }
      this.loading = true;
      imgByQr({ uploadToken: this.qrCode })
        .then(({ code, data }) => {
          if (code === 0) {
            this.images = (data && data.images) || [];
            if (showEmptyTip && !this.images.length) {
              this.$message.warning("暂无扫码上传图片");
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 上传到 OSS 后保存图片
    uploadToOSS: function (res) {
      const name = String(Date.parse(new Date()) + res.file.name);
      const key = "transfer/" + name;
      OSSsign({ path: "transfer/" }).then(({ code, data }) => {
        if (code !== 0) {
          return;
        }
        const forms = new FormData();
        forms.append("name", name);
        forms.append("key", key);
        forms.append("OSSAccessKeyId", data.accessId);
        forms.append("policy", data.policy);
        forms.append("signature", data.signature);
        forms.append("success_action_status", 200);
        forms.append("file", res.file);
        let host = data.host;
        if (location.href.indexOf("https") > -1 && host.indexOf("https") === -1) {
          host = host.replace("http", "https");
        }
        axios({
          method: "post",
          url: host,
          data: forms,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((uploadRes) => {
          if (uploadRes.status == 200) {
            this.saveImg(`${data.customDomain}/${key}`);
          }
        });
      });
    },
    // 保存图片到扫码上传独立接口
    saveImg: function (url) {
      imgSaveByQr({
        uploadToken: this.qrCode,
        qrCodePayload: "/wmsImgUpload?uploadToken=" + this.qrCode,
        imageList: [url],
      }).then(({ code }) => {
        if (code === 0) {
          this.$message.success("添加成功");
          this.getImages();
        }
      });
    },
    // 删除单张图片
    delImg: function (record, index) {
      if (!record.id) {
        this.images.splice(index, 1);
        return;
      }
      deleteImageByQrApi({ id: record.id }).then(() => {
        this.$message.success("删除成功！");
        this.images.splice(index, 1);
      });
    },
  },
};
</script>

<style scoped>
.photo-upload-row {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

.qr-inline {
  width: 150px;
  height: 150px;
  border: 1px solid #e1e5e8;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex-shrink: 0;
}

.photo-thumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.preview__li {
  width: 150px;
  height: 150px;
  position: relative;
  background: #fafcfd;
  flex-shrink: 0;
}

.preview__li .el-icon-error {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 18px;
  cursor: pointer;
}

.photo-box {
  width: 180px;
  height: 150px;
  border: 1px dashed #b9c8d1;
  background: #fafcfd;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #73808a;
  font-size: 28px;
  cursor: pointer;
}

.photo-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
}

.photo-actions>>>.el-button {
  min-width: 140px;
  height: 44px;
}
</style>
